<div>
    <!-- Incluindo o componente PDirectComponent e passando o store_name -->
    <app-p-direct [store_name]="subdomain" [slick_id]="slick_id" [widget_id]="widget_id"></app-p-direct>
</div>
